import {
    Component,
    OnChanges,
    HostListener,
    EventEmitter,
    ElementRef,
    Output,
    Input,
} from '@angular/core';

import { GroupedFilter } from '../../../interfaces/user.interface';

export interface FilterOption {
    route: string;
    name: string;
    plan: string;
}

@Component({
    selector: 'mapp-admin-grouped-selector',
    templateUrl: './admin-grouped-selector.component.html',
    styleUrls: ['./admin-grouped-selector.component.scss'],
    standalone: false,
})
export class AdminGroupedSelectorComponent implements OnChanges {
    @Input() filter: GroupedFilter = {
        name: '',
        options: [
            {
                name: '',
                plan: '',
            },
        ],
        multiselect: true,
    };

    @Input() selectedValues: string[] = [];

    @Input() defaultPlaceholder = 'Select minds';

    @Input() isDisabled: boolean;

    @Input() showLoader: boolean;

    @Input() loaderMessage: string;

    @Input() placeholderWhenSelected = 'items selected';

    @Input() isFederated: boolean;

    @Output() selectedValuesChange = new EventEmitter<string[]>();

    placeholder = '';

    showDropdown = false;

    showStarterToolsOptions = false;

    showProToolsOptions = true;

    /**
     *
     * @param elementRef
     */
    constructor(private readonly elementRef: ElementRef) {}

    /**
     *
     */
    ngOnChanges() {
        this.adaptPlaceholder();
    }

    /**
     *
     */
    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
    }

    /**
     *
     * @param option
     */
    toggleSelection(option: string) {
        this.selectedValues = this.isSelected(option)
            ? this.selectedValues.filter((value) => value !== option)
            : [...this.selectedValues, option];

        this.adaptPlaceholder();
        this.selectedValuesChange.emit(this.selectedValues);
    }

    /**
     *
     */
    adaptPlaceholder() {
        switch (this.selectedValues?.length) {
            case 0:
            case undefined:
                this.placeholder = this.defaultPlaceholder;
                break;
            case 1:
                this.placeholder =
                    this.filter.options.find((option) => option.name === this.selectedValues[0])
                        .name || '';
                break;
            default:
                this.placeholder = `${this.selectedValues?.length} ${this.placeholderWhenSelected}`;
        }
    }

    /**
     *
     * @param option
     */
    isSelected(option: string): boolean {
        return this.selectedValues?.includes(option);
    }

    /**
     *
     * @param values
     */
    setSelectedValues(values: string[]) {
        this.selectedValues = values;
        this.adaptPlaceholder();
    }

    /**
     *
     * @param event
     */
    @HostListener('document:click', ['$event'])
    onClick(event: MouseEvent) {
        const targetElement = event.target as HTMLElement;
        if (!this.showDropdown || this.elementRef.nativeElement.contains(targetElement)) {
            return;
        }
        this.showDropdown = false;
    }

    /**
     *
     */
    get liteOptions() {
        return this.filter.options.filter((option) => option.plan === 'lite');
    }

    /**
     *
     */
    get proToolsOptions() {
        return this.filter.options.filter((option) => option.plan === 'premium');
    }

    /**
     *
     */
    get otherToolsOptions() {
        return this.filter.options.filter((option) => option.plan === 'other');
    }

    /**
     *
     */
    toggleStarterToolsDropdown() {
        this.showStarterToolsOptions = !this.showStarterToolsOptions;
    }

    /**
     *
     */
    toggleProToolsDropwdown() {
        this.showProToolsOptions = !this.showProToolsOptions;
    }
}
